import mori from 'mori';

export default function(data, metaData) {
  // The base column is just a version of the first header column
  const baseColumn = mori.set([
    mori.get(mori.first(metaData.immutableHeaders), 'characteristic'),
    mori.get(mori.first(metaData.immutableHeaders), 'label'),
  ]);

  // For Geomulti indicators, the second column is the child, so we also need
  // that selector
  const childColumn = mori.getIn(data.config, ['globalRules', 'Geomulti']) ?
    mori.set([
      mori.get(mori.nth(metaData.immutableHeaders, 1), 'characteristic'),
      mori.get(mori.nth(metaData.immutableHeaders, 1), 'label'),
    ]) :
    false;

  return [baseColumn, childColumn];
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/services/getColumnKeys.js